import { useMutation, useQueryClient } from '@tanstack/react-query';
import { requestPlan } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useRequestPlan({ handleClose }) {
  const queryclient = useQueryClient();
  const Request = useMutation({
    mutationFn: requestPlan,
    mutationKey: ['requestPlan'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        return toastEmitter('error', responseData?.error?.message);
      }
      handleClose();
      queryclient.invalidateQueries(['getRequestedPlan']);
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
